require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./stratgie-de-lenseignement-2-0-0.json") })
        }
      }, "path---stratgie-de-lenseignement-2-0-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---stratgie-de-lenseignement-2-0-0!./.cache/json/stratgie-de-lenseignement-2-0-0.json
// module id = 577
// module chunks = 231608221292675